export function provinceEliminarModal(item,entity){
    return {
      id: item.id,
      title: "Por favor, confirme que desea eliminar esta provincia",
      subtitle:
        "¡CUIDADO! Eliminar esta provincia ELIMINARÁ también TODAS sus POBLACIONES y CENTROS DE TRABAJO situados en ellas. Esta acción no se puede deshacer.",
      texts: [
        {
          text: "Nombre de la provincia",
          value: item.name,
        },
        {
          text: "País al que pertenece",
          value: item.country.name,
        },
      ],
      buttons: [
        {
          text: "Confirmar",
          action: "delete",
          classes: "unsafe",
          entity: entity,
          actionType: "mutation",
        },
        {
          text: "Cancelar",
          action: "closeModal",
          classes: "safe",
          entity: entity,
        },
      ],
    };
}